import { DialogActions, DialogContent } from '@material-ui/core'
import styled from 'styled-components'

export const CustomDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: flex-end;
`

export const CustomDialogContent = styled(DialogContent)`
  padding: 0;
  border-top: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  &:first-child {
    padding: 0 !important;
  }
`

export const TextContainer = styled.div`
  padding: 16px 24px;
`
